import { useState, useRef, useEffect } from "react";
import { CARD, CARD2, BD, TX, TX2, GR, BL, RD } from "../../utils/constants";
import axios from "../../utils/api";

export default function StockSearch({ onSelect }) {
  const [query, setQuery]     = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen]       = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");
  const debounceRef = useRef(null);
  const boxRef       = useRef(null);

  useEffect(() => {
    clearTimeout(debounceRef.current);
    if (!query.trim()) { setResults([]); setOpen(false); return; }
    debounceRef.current = setTimeout(async () => {
      try {
        const res = await axios.get("/api/scan/search", { params: { q: query.trim() } });
        setResults(res.data.results || []);
        setOpen(true);
      } catch { setResults([]); }
    }, 300);
    return () => clearTimeout(debounceRef.current);
  }, [query]);

  useEffect(() => {
    const handler = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const pick = async (symbol) => {
    setOpen(false);
    setResults([]);
    setLoading(true);
    setError("");
    try {
      await onSelect(symbol);
      setQuery("");
    } catch (e) {
      setError(e?.response?.data?.error || `Couldn't find "${symbol}".`);
    } finally {
      setLoading(false);
    }
  };

  const submitRaw = () => {
    const sym = query.trim().toUpperCase();
    if (sym) pick(sym);
  };

  return (
    <div ref={boxRef} style={{ position: "relative", marginBottom: 12 }}>
      <div style={{ display: "flex", gap: 8 }}>
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submitRaw()}
          placeholder="Search any stock — symbol or name (e.g. AAPL or Apple)"
          style={{ flex: 1, background: CARD2, border: `1px solid ${BD}`, borderRadius: 8, padding: "10px 14px", color: TX, fontSize: 11, fontFamily: "'IBM Plex Mono',monospace", outline: "none" }}
        />
        <button
          className="btn"
          onClick={submitRaw}
          disabled={loading || !query.trim()}
          style={{ background: loading ? CARD2 : `linear-gradient(135deg,${GR},${BL})`, border: "none", borderRadius: 8, padding: "0 18px", color: loading ? TX2 : "#000", fontWeight: 700, fontSize: 10, cursor: loading || !query.trim() ? "not-allowed" : "pointer" }}
        >
          {loading ? "…" : "GO"}
        </button>
      </div>
      {error && <div style={{ color: RD, fontSize: 9, marginTop: 6 }}>{error}</div>}
      {open && results.length > 0 && (
        <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: CARD, border: `1px solid ${BD}`, borderRadius: 8, overflow: "hidden", zIndex: 50, boxShadow: "0 12px 30px rgba(0,0,0,0.4)" }}>
          {results.map((r) => (
            <div
              key={r.symbol}
              onClick={() => pick(r.symbol)}
              className="hov-row"
              style={{ padding: "9px 13px", cursor: "pointer", display: "flex", justifyContent: "space-between", gap: 10, borderBottom: `1px solid ${BD}` }}
            >
              <span style={{ fontWeight: 700, fontSize: 11, color: TX, flexShrink: 0 }}>{r.symbol}</span>
              <span style={{ fontSize: 9, color: TX2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
